import React, { Component } from 'react';
import '../App.css';
import { Panel } from 'react-bootstrap';
import GoogleTrends from '../Engines/GoogleTrends.js';
import Description from './Description.js';

const engines = new Map();

//Description of this group.
//This is what user will see by pressing the info icon.
const description = (
  <div>
    This window shows you the popularity of your query as a Google search query
    in different times, through the use of Google Trends. Click "Look it up!"
    to see full details.
  </div>
)

class Trends extends Component {
  constructor () {
    super();
    engines.set("GoogleTrends", {});
    this.state = {
      resultCount: 0,
      open: true,
      searchQuery: '',
      noSearches: true
    };
  }

  clear(){
    engines.set("GoogleTrends", {});
    this.setState({
      resultCount: 0,
      query: '',
      open: true,
    });
  }

  addResult(source, content, searchQuery) {
    if (engines.has(source)) {
      engines.set(source, content)
      this.setState({
        resultCount: this.state.resultCount + 1,
        query: searchQuery,
        noSearches: false
      });
    }
  }

  handleClick() {
    this.setState({open: !this.state.open});
  }

  header(){
    return(
      <div className="resultBox__header" onClick={ ()=> this.setState({ open: !this.state.open })}>
        <h3 className="resultBox__title">Google Trends</h3>
      </div>
    );
  }

  render() {
    var searchLink = "http://www.google.com/search?q=" + this.state.query;
    if (this.state.resultCount > 0) {
      return (
        <Panel className="resultBox" collapsible expanded={this.state.open} header={this.header()}>
          <div className="resultBox__content">

            <p>
              <a href={searchLink} target="_blank">
                <b>
                  <font color="#4285f4"> Look it up! </font>
                </b>
              </a>
            </p>

            <div id="trendsDiv">
              <GoogleTrends content={engines.get("GoogleTrends")}/>
            </div>

          </div>
          <div className="resultBox__footer">

            <div className="resultBox__help">
              <Description description={description}/>
              <p>What is this report about?</p>
            </div>

          </div>
        </Panel>
      );
    } else if ( !(this.state.noSearches)) {
      //The only difference here is to take out the "look it up!" link away
      // during the loading, since there is no query for it to use.
        return (
          <Panel className="resultBox" collapsible expanded={this.state.open} header={this.header()}>
            <div className="resultBox__content">
              <div id="trendsDiv">
                <GoogleTrends content={engines.get("GoogleTrends")}/>
              </div>
            </div>
            <div className="resultBox__footer">

              <div className="resultBox__help">
                <Description description={description}/>
                <p>What is this report about?</p>
              </div>

            </div>
          </Panel>
        );
    } else {
      return <div/>;
    }
  }
}

export default Trends;



// WEBPACK FOOTER //
// ./client/src/Groups/Trends.js